const sidebarToggler = () => {

    $('#btnNews').click(e => {
        $('.news-sidebar').css('right', '0');
        $('.transparent-fill').show();
        $('body').css('overflow', 'hidden');
        e.preventDefault();
    })
    
};

export {
    sidebarToggler
};
